export const enumPermisosAuditoriaLogs = Object.freeze({
  AUDITORIA_LOGS: 41100,
});

